import styled from 'styled-components';

export const ProcessBarStyled = styled.div`
  position: relative;
  padding: ${props => props.theme.size.rap};

  .set-wrap {
    position: relative;
    z-index: 2;
    text-align: center;
    font-size: 1.4rem;
    font-weight: bold;
    margin-top: 2rem;
  }

  .processBar {
    position: relative;
    &:before,
    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 100%;
      aspect-ratio: 1 / 1;
      border-radius: 50%;
      border: 10px solid #ededed;
      content: '';
      animation: scale 1s ease-in-out infinite;
    }
    &:after {
      border: 6px solid #ededed;
      animation-delay: 0.3s;
    }
  }
  .CircularProgressbar-path {
    stroke: ${props => props.theme.color.primary};
  }
  .CircularProgressbar-trail {
  }
  .CircularProgressbar-text {
    fill: ${props => props.theme.color.primary};
  }
  .CircularProgressbar-background {
  }

  @keyframes scale {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    70% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 0;
    }
  }

  .animation {
    width: 100%;
  }
  text-align: center;

  .message {
    margin-top: 1rem;
    font-size: 1.2rem;
    color: #666;
  }
`;
